import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';

const ContactForm = ({ lightPlaceholder }) => {
	const hasLightPlaceholder = lightPlaceholder ? true : false;
	const [formLoaded, setFormLoaded] = useState(false);
	const [html, setHTML] = useState({ __html: "" });


	const processForm = (ev) => {
		ev.preventDefault();
		const theForm = document.querySelector('.contact-form form')
		const formData = new FormData(theForm);
		//{
		//	name: document.querySelector('.contact-form form #Nome').value,
		//	email: document.querySelector('.contact-form form #Email').value,
		//	message: document.querySelector('.contact-form form #Message').value
		//}

		axios.post('/forms/iscrizione', formData, {
			headers: {
				'X-Requested-With': 'XMLHttpRequest'
			}
		}).then(response => {
			const res = response.data;
			//return { __html: res };
			setHTML({ __html: res })
			setFormLoaded(!formLoaded);
			setTimeout(() => {
				window.scrollTo({ top: document.querySelector('.contact-form-container').offsetTop - 120, behavior: "smooth" })
			}, 100)

		})
	}

	useEffect(() => {
		const fetchData = async () => {
			axios.get(`/forms/Iscrizione`, {
				headers: {
					'X-Requested-With': 'XMLHttpRequest'
				}
			}).then(response => {
				const res = response.data;
				//return { __html: res };
				setHTML({ __html: res })
				setFormLoaded(!formLoaded);
			})
		}
		fetchData();
	}, []);


	useEffect(() => {
		const theForm = document.querySelector('.contact-form form')
		if (!theForm) return;

		if (theForm.attachEvent) {
			theForm.attachEvent("submit", processForm);
		} else {
			theForm.addEventListener("submit", processForm);
		}

	}, [formLoaded]);

	return (
		<>
			<div dangerouslySetInnerHTML={html} className={`contact-form ${hasLightPlaceholder ? "light-placeholder" : ""}`} />
		</>
	);
};

export default ContactForm;
